import {createAction, props} from "@ngrx/store";

export const TOGGLE_AZ_VISIBILITY = '[AvailabilityZone] Toggle AZ Visibility';

export const toggleAZVisibility = createAction(
  TOGGLE_AZ_VISIBILITY,
  props<{ azId: string, isVisible: boolean }>()
);
